import Config from '@config';
import { initializeMeterThroughputsApi } from '@gasbi/shared';

import axiosBaseQuery from '@/utils/axiosBaseQuery';

const meterThroughputs = initializeMeterThroughputsApi({
  baseUrl: Config.VITE_API_CLIENT_URL,
  baseQuery: axiosBaseQuery,
});

export const { meterThroughputsApi, useGetMeterThroughputsQuery } =
  meterThroughputs;
